import services from '../services'
import * as types from './mutation-types'

export const GetCustomization = async ({ commit }) => {
  await services.getCustomization().then(res => {
    commit(types.SET_CUSTOMIZATION, res.data.data)
  })
}

export const SaveCustomization = async ({ commit }, obj) => {
  await services.saveCustomization(obj).then(res => {
    commit(types.SET_CUSTOMIZATION, res.data.data)
    return res
  })
}

export const DeleteImage = async ({ commit }, field) => {
  await services.deleteImage(field).then(res => {
    return res
  })
}
